<template>
	<span class="meta-info">
		<span class="meta-info--is-toggle" v-if="type === 'toggle'">
			<a class="meta-info__icon uk-margin-small-right" tabindex="-1" :uk-toggle="ukToggle"><span :uk-icon="icon"></span></a>

			<div :id="toggleId" hidden>
				<div class="meta-info__content uk-section-secondary uk-margin-small-bottom uk-padding-small uk-text-small">
					<slot></slot>
				</div>
			</div>
		</span>

		<div class="meta-info uk-margin-small-top uk-margin-small-bottom uk-flex" v-if="type === 'default'">
			<div class="meta-info__icon uk-margin-small-right uk-flex-none" :uk-icon="icon"></div>
			<div class="meta-info__content uk-text-meta">
				<slot></slot>
			</div>
		</div>
	</span>
</template>

<script>
export default {
	name: 'meta-info',
	props: {
		type: {
			type: String,
			default: 'default'
		},
		icon: {
			type: String,
			default: 'info'
		}
	},
	computed: {
		toggleId () {
			return 'meta-info-' + this._uid
		},
		ukToggle () {
			return 'target: #' + this.toggleId + '; animation: uk-animation-fade'
		}
	}
}
</script>

<style lang="scss" scoped>
	.meta-info--is-toggle {
		.meta-info__content {
			position: relative;
			margin-top: 1em;
			border: 2px solid #E0E0E0;
			border-radius: .2em;
			color: #F0F0F0;
		}

		.meta-info__content:after {
			bottom: 100%;
			left: 2em;
			border: solid transparent;
			content: " ";
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
			border-color: rgba(240, 240, 34, 0);
			border-bottom-color: #222;
			border-width: 14px;
			margin-left: -14px;
		}

		.meta-info__content:after,
		.meta-info__content:before {
			bottom: 100%;
			left: 32px;
			border: solid transparent;
			content: " ";
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
		}

		.meta-info__content:after {
			border-color: rgba(34, 34, 34, 0);
			border-bottom-color: #222;
			border-width: 14px;
			margin-left: -14px;
		}
		.meta-info__content:before {
			border-color: rgba(224, 224, 224, 0);
			border-bottom-color: #e0e0e0;
			border-width: 17px;
			margin-left: -17px;
		}
	}
</style>
